<script lang="ts">
  export let data: any;
</script>

<section class="product_title">
  {#if data?.brandName !== null && data?.brandNameEn !== 'Default Value'}
    <div class="brand-name" style:color={data?.brandColor}>{data?.brandName}</div>
  {/if}
  <div class="product-name">{data?.name}</div>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .product_title {
    background-color: $neutral-light-04;
  }
  .brand-name {
    color: $icon-only-icon-blue;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  }
  .product-name {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: $neutral-dark-01;
    margin: 0 0 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-transform: capitalize;
  }

  @include desktop-min-width {
    .product_title {
      padding: 0;
      background-color: $primary-white;
    }
    .brand-name {
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
    }
    .product-name {
      font-weight: 500;
      font-size: 20px;
      line-height: 22px;
      margin-top: 6px;
    }
  }
</style>
